<template>
  <el-form
    label-position="top"
    ref="form"
    :model="form"
    size="small"
    :rules="rules"
  >
    <el-form-item label="园区">
      <el-input :value="display.parkName" readonly />
    </el-form-item>
    <el-form-item label="地块">
      <el-input :value="display.landName" readonly />
    </el-form-item>
    <el-form-item label="起始日期" prop="begin">
      <el-input
        v-if="planning"
        :value="new Date(form.begin).format('yyyy年 MM月 dd日')"
        readonly
      />
      <el-date-picker
        v-else
        v-model="form.begin"
        :picker-options="pickerOptions"
        type="date"
        default-time="00:00:00"
        value-format="timestamp"
        placeholder="选择日期时间"
      >
      </el-date-picker>
    </el-form-item>
    <el-form-item v-if="form.begin" label="品种" prop="variId">
      <el-input v-if="planning" :value="display.variName" readonly />
      <el-select v-else v-model="form.variId" placeholder="请选择品种" @change="selectVariety">
        <el-option
          v-for="v in varieties"
          :key="v.id"
          :label="v.name"
          :value="v.id"
        />
      </el-select>
    </el-form-item>
    <el-form-item v-if="form.variId" label="种植方案" prop="scheId">
      <el-input v-if="planning" :value="form.scheName" readonly />
      <el-select v-else v-model="form.scheId" placeholder="请选择种植方案">
        <el-option
          v-for="s in schemes"
          :key="s.id"
          :label="s.name"
          :value="s.id"
        >
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item v-if="form.scheId" label="种植日期">
      <el-input  :value="new Date(form.plant).format('yyyy-MM-dd')" readonly ></el-input>
    </el-form-item>
    <el-form-item v-if="form.scheId" label="采摘日期">
      <el-input  :value="new Date(form.harvest).format('yyyy-MM-dd')" readonly ></el-input>
    </el-form-item>
    <!-- <el-form-item label="计划负责人" prop="planLeader">
      <el-select
        v-model="form.planLeader"
        placeholder="请选择计划负责人"
      >
        <el-option
          v-for="p in persons"
          :key="p.id"
          :label="p.name"
          :value="p.id"
        />
      </el-select>
    </el-form-item> -->
    <el-form-item v-if="!planning">
      <el-button type="warning" @click="clearFrom">清空</el-button>
      <el-button type="primary" @click="save">填好了，保存</el-button>
    </el-form-item>
  </el-form>
</template>
<script>
import rules from './plan-detail-rules.js'
import { getVarietiesByName } from '@/api/variety.js'
import { personSearch } from '@/api/person.js'
import { getProgrammeData, getSchemeDetailById,getProgrammeDataByVarietyId } from '@/api/programme.js'
import { planListAdd } from '@/api/plan-list.js'
export default {
  name: 'PlanDetailForm',
  data() {
    return {
      /**
       * 要提交的表单数据，用于创建种植计划
       */
      form: {
        landId: undefined,
        variId: undefined,
        begin: undefined, // 计划开始（但不一定是开始栽种，可能有个准备阶段）
        end: undefined, // 计划结束（但不一定是采摘上市，采摘可能持续一段时间）
        days: undefined, // 计划总时长（天数）
        plant: undefined, // 栽种日期
        harvest: undefined, //采摘开始日期（预期上市日期）
        scheId: undefined,
        suggests: [],
        phases: [],
      },
      /**
       * 要显示的表单数据，用于显示已有种植计划的地块
       */
      display: {
        parkName: '',
        landName: '',
        variName: '',
      },

      /**
       * 当前地块目前是否已经有种植计划
       */
      planning: false,
      /**
       * 品种选项
       */
      varieties: [],
      /**
       * 种植方案选项
       */
      schemes: [],
      /**
       * 负责人选项
       */
      persons: [],
      /**
       * 表单验证规则
       */
      rules: rules,
      /**
       * 日期选择范围设置
       * */
      pickerOptions:{
        // disabledDate(time) {
        //   return time.getTime() < Date.now() ;
        // }
      }
    }
  },

  watch: {
    /**
     * 监听种植方案下拉框选择，刷新预览
     */
    'form.scheId': function (val) {
      this.refreshPreview()
    },
    /**
     * 监听计划起始日期选择，刷新预览
     */
    'form.begin': function (val) {
      this.refreshPreview()
    },
  },
  methods: {

    // 选中品种，根据品种选择合适方案
    selectVariety() {
      this.form.scheId=""
      getProgrammeDataByVarietyId(this.form.variId).then((resp) => {
        this.schemes = resp.data
      })
    },
    /**
     * 父组件调用，初始设置地块的种植计划
     */
    setPlan(plan) {
      this.form.landId = plan.landId
      // 园区和地块的信息是固有的
      this.display.landName = plan.landName
      this.form.parkId = plan.parkId
      this.display.parkName = plan.parkName
      // 判断地块当前是否有种植计划，然后分别处理
      this.planning = typeof plan.planId === 'number'
      if (this.planning) {
        console.log('第一种情况：：该地块有种植计划')
        console.log(plan)
        // 把信息显示出来即可
        this.form.variId = plan.variId
        this.form.begin = plan.begin
        this.form.scheId = plan.scheId
        this.form.scheName = plan.scheName
        this.display.variName = plan.variName
        this.form.plant=plan.plant
        this.form.harvest=plan.harvest
        this.form.days=plan.days
      } else {
        console.log('另一种情况：：该地块没有种植计划，空闲')
        // 准备几个下拉选框
        this.initVarietyOptions()
        this.refreshSchemeOptionsByVariety() // TODO 应该是选了品种之后才根据品种生成种植方案列表
        this.personSearchGet()
        // 然后等待用户操作，监听到用户选择了日期和方案之后，就预生成种植计划并通知外层组件
      }
    },
    /**
     * 根据品种id查询得到种植方案选项（这里不应该查出具体的种植方案，只应该查出id+name，用来生成下拉框，等到下拉框选择了之后再查询具体的种植方案）
     */
    refreshSchemeOptionsByVariety(varietyId) {
      getProgrammeData({
        pageSize: 100000000,
      }).then((resp) => {
        this.schemes = resp.data.list
      })
    },
    /**
     * 初始化品种选项
     */
    initVarietyOptions() {
      getVarietiesByName().then((resp) => {
        this.varieties = resp.data
      })
    },
    personSearchGet() {
      personSearch({
        pageSize: 100000000,
        enterpriseId: this.enterpriseId,
      }).then((resp) => {
        this.persons = resp.data.list.filter((item) => {
          return item.status == '0'
        })
      })
    },
    clearFrom() {
      this.$refs.form.resetFields()
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          planListAdd(this.form).then((data) => {
            this.$router.push('../list')
          })
        }
      })
    },
    /**
     * 刷新预览。当且仅当（地块空闲+起始日期或种植方案发生变化）时调用，刷新右侧日程表和任务树。
     */
    refreshPreview() {
      if (this.planning) return // 如果已经有种植计划了，则不要因为日期或方案的变化而刷新
      const { scheId, begin } = this.form
      if (begin && typeof scheId === 'number') {
        // begin和scheme两个都有效时才刷新预览
        this.fillPreview()
      } else {
        // begin和scheme两个有一个无效时，派发事件清空日程表和阶段树
        this.$emit('preview-clear')
      }
    },
    /**
     * 预生成种植计划，供refreshPreview()调用
     */
    fillPreview() {
      const { scheId, begin } = this.form
      getSchemeDetailById(scheId).then((resp) => {
        const scheme = resp.data
        const phases = []
        const suggests = []
        let day = begin // 日期游标，遍历中每过一个阶段会增加为下一个阶段的开始
        // 把选中的方案的阶段转为Json对象（原本是string）然后遍历它
        JSON.parse(scheme.phases).forEach((phase, index) => {
          const tail = day + phase.dutation * 1000 * 60 * 60 * 24 // 计算阶段结束日期
          // 写入阶段列表
          phases.push({
            index: phase.index,
            name: phase.name,
            days: phase.dutation,
            begin: day,
            end: tail,
            badge: phase.badge,
          })

          // 循环并写入建议列表
          phase.suggest.forEach((s) => {

            suggests.push({
              phase: phase.stage,
              content: s.suggest,
              begin: phases[index].begin + (s.stageDay - 1) * 1000 * 60 * 60 * 24,
            })
          })
          // 本阶段的结束作为下阶段的开始
          day = tail
        })
        this.form.plant=this.form.begin+(resp.data.plantDay-1)*1000*60*60*24
        this.form.harvest=this.form.begin+(resp.data.harvestDay-1)*1000*60*60*24
        this.form.days = scheme.duration
        this.form.suggests = suggests
        this.form.phases = phases
        this.form.end = day
        let d = new Date(this.form.end)
        // 派发事件，填充或刷新右侧日程表
        this.$emit('preview-fill', { suggests: suggests, phases: phases })
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/product/plan/PlanDetailForm.vue